<template>
    <Modal :title="props.title">
        <template v-slot:body>
            {{ props.text }}
        </template>
        <template v-slot:footer>
            <input type="button" :value="props.cancelBtnText" class="button button-secondary cancel-button" @click="cancel()" />
            <input type="button" :value="props.confirmBtnText" class="button" :class="{ 'button-danger': dangerous }" @click="ok()" />
        </template>
    </Modal>
</template>

<script setup>
    import { defineProps, defineEmits } from 'vue';
    import { Modal as ModalLib } from 'jenesius-vue-modal';
    import Modal from './Modal.vue';

    const props = defineProps({
        title: {
            type: String,
            default: ''
        },

        text: {
            type: String,
            reqiured: true
        },

        confirmBtnText: {
            type: String,
            default: 'OK'
        },

        cancelBtnText: {
            type: String,
            default: 'Cancel'
        },

        dangerous: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits([ModalLib.EVENT_PROMPT]);

    async function ok() {
        emit(ModalLib.EVENT_PROMPT, true);
    }

    async function cancel() {
        emit(ModalLib.EVENT_PROMPT, false);
    }
</script>

<style scoped>
    .container {
        width: 500px;
    }

    .cancel-button {
        margin-right: 10px;
    }
</style>
